import useTranslate from "../../../hooks/useTranslate";
import InviteBannerBangerDesk from "../../../assets/images/banger/invite_friend_desc.webp";
import InviteBannerBangerMob from "../../../assets/images/banger/invite_friend_mob.webp";
import InviteBannerDesc from "../../../assets/images/glory/invite_desc.webp";
import InviteBannerMob from "../../../assets/images/glory/invite_mob.webp";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

import "./styles.sass";

const InviteFriendBanner = () => {
  const t = useTranslate();
  const projectName = import.meta.env.VITE_APP_PROJECT_NAME;
  const { isDesktop } = useBreakpoint();

  const getBanner = () => {
    if (projectName === "banger") {
      return isDesktop ? InviteBannerBangerDesk : InviteBannerBangerMob;
    }
    return isDesktop ? InviteBannerDesc : InviteBannerMob;
  };
  const description =
    projectName === "banger"
      ? t("referral.banner.desc").replace("Glory", "Banger")
      : t("referral.banner.desc");

  return (
    <div className="InviteFriendBanner">
      <img src={getBanner()} className="InviteFriendBanner-img" alt="invite" />
      <div className="InviteFriendBanner-banner">
        <span className="InviteFriendBanner-banner__title">
          {t("profile.account.invite")}
        </span>
        <span className="InviteFriendBanner-banner__desc">{description}</span>
      </div>
    </div>
  );
};

export default InviteFriendBanner;
